import React from 'react'
import { Typography, Stack } from '@mui/material'
import { Form } from 'formik'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { NumberField, TextField } from 'src/Libs/inputs/formik'
import { UnitTypes } from 'src/Libs/types'
import Checkbox from '../../../inputs/formik/Checkbox'

const useStyles = makeStyles()(theme => ({
  box: {
    [theme.breakpoints.up('md')]: {
      flex: 1,
    },
  },
  labelTitle: {
    fontWeight: 500,
  },
}))

/**
 * Component for displaying the form of Edison step
 */
const EdisonWallBoxForm: React.VFC = () => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <Form
    //placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
    >
      <Stack spacing={4} direction={{ xs: 'column', md: 'row' }}>
        <Stack className={classes.box} spacing={4}>
          <Typography sx={{ pt: 2 }} variant="h5">
            {t('installation-statement.edison.form.serial-number.title')}
          </Typography>
          <TextField required={true} name={'serialNumbers.connect'} label={t('installation-statement.edison.form.serial-numbers.connect')} />
          <TextField
            sx={{ mb: 2 }}
            required={true}
            name={'serialNumbers.power'}
            label={t('installation-statement.edison.form.serial-numbers.power')}
          />
          <Typography sx={{ pt: 2 }} variant="h5">
            {t('installation-statement.edison.form.vehicle-information.title')}
          </Typography>
          <TextField
            required={true}
            name={'vehicleInformation.manufacturer'}
            label={t('installation-statement.edison.form.vehicle-information.manufacturer')}
          />
          <TextField required={true} name={'vehicleInformation.model'} label={t('installation-statement.edison.form.vehicle-information.model')} />
          <NumberField
            label={t('installation-statement.edison.form.vehicle-information.battery-capacity')}
            required={true}
            name={'vehicleInformation.batteryCapacity'}
            fullWidth={true}
            suffix={UnitTypes.kiloWattHour}
            ignoreDefaultValue
          />
          <TextField
            sx={{ mt: 0 }}
            required={true}
            name={'vehicleInformation.softwareVersion'}
            label={t('installation-statement.edison.form.vehicle-information.software-version')}
          />
        </Stack>

        <Stack className={classes.box} spacing={1}>
          <Typography sx={{ pb: 2 }} variant="h5">
            {t('installation-statement.edison.form.functionality-tests.title')}
          </Typography>
          <Checkbox
            name={'functionalityTests.fullyInstalled'}
            label={`${t('installation-statement.edison.form.functionality-tests.fully-installed')}*`}
          />
          <Checkbox name={'functionalityTests.configured'} label={`${t('installation-statement.edison.form.functionality-tests.configured')}*`} />
          <Checkbox
            name={'functionalityTests.scenarioOneTested'}
            label={
              <>
                <span className={classes.labelTitle}>{t('installation-statement.edison.form.functionality-tests.scenario-one-tested.title')}</span>{' '}
                <span>{t('installation-statement.edison.form.functionality-tests.scenario-one-tested.body')}*</span>
              </>
            }
          />
          <Checkbox
            name={'functionalityTests.scenarioTwoTested'}
            label={
              <>
                <span className={classes.labelTitle}>{t('installation-statement.edison.form.functionality-tests.scenario-two-tested.title')}</span>{' '}
                <span>{t('installation-statement.edison.form.functionality-tests.scenario-two-tested.body')}</span>
              </>
            }
          />
          <Checkbox
            name={'functionalityTests.customerBriefed'}
            label={`${t('installation-statement.edison.form.functionality-tests.customer-briefed')}*`}
          />

          <Typography sx={{ pt: 2 }} variant="body2">
            {t('installation-statement.edison.form.functionality-tests.bidirectional.title')}
          </Typography>
          <Checkbox
            name={'functionalityTests.biDirectionalDCChargingConfiguration.positionedAtChargingPoint'}
            label={`${t('installation-statement.edison.form.functionality-tests.bidirectional.positioned-at-charging-point')}`}
          />
          <Checkbox
            name={'functionalityTests.biDirectionalDCChargingConfiguration.chargingLocationDefined'}
            label={`${t('installation-statement.edison.form.functionality-tests.bidirectional.charging-location-defined')}`}
          />
          <Checkbox
            name={'functionalityTests.biDirectionalDCChargingConfiguration.functionActivated'}
            label={`${t('installation-statement.edison.form.functionality-tests.bidirectional.function-activated')}`}
          />
        </Stack>
      </Stack>
    </Form>
  )
}

export default EdisonWallBoxForm
